import { ManufacturingOrder } from './manufacturing-order';

export class ManufacturingOrderPageable {
  constructor(
    public manufacturingOrders: ManufacturingOrder[] = [],
    public totalPage: number,
    public total: number,

  ) {}

  clone() {
    return new ManufacturingOrderPageable(
      this.manufacturingOrders,
      this.totalPage,
      this.total
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-pageabe.ts